var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"c-theme-tile",attrs:{"to":{
    name: 'Lesson',
    params: { lessonSlug: _vm.lessonSlug, unitSlug: _vm.unitSlug },
  },"lang":_vm.locale}},[(_vm.cover)?_c('picture',{staticClass:"c-theme-tile__pic"},[_c('img',{staticClass:"c-theme-tile__img",attrs:{"src":("" + _vm.cover),"alt":_vm.altText,"title":_vm.imageCredit}})]):_vm._e(),_c('VHeading',{staticClass:" c-theme-tile__title",attrs:{"header":"h2"}},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }